import React from 'react';
import * as moment from 'moment-timezone';
import { formatTimeFromPresent } from '../../shared/dateUtils';
import LiveStreamItem from './LiveStreamItem';
import { getLiveStreamIcon, getLiveStreamImageUrl } from '../utils';

interface Props {
  liveStreamsNow: any,
  upcomingLiveStreams: any,
  pastLiveStreams: any,
  showLiveStream: any,
}

class LiveStreamList extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.showLiveStream = this.showLiveStream.bind(this);
  }

  showLiveStream(e) {
    this.props.showLiveStream(e);
  }

  render() {
    let { liveStreamsNow, upcomingLiveStreams, pastLiveStreams } = this.props;
    return(
      <div className="p3">
        {liveStreamsNow.length > 0 &&
          <React.Fragment>
            <div className="fs-md cs-black fw-sb mb2">Live Now</div>
            {liveStreamsNow.map((liveStream) => {
              return(
                <LiveStreamItem
                  liveStream={liveStream}
                  isLive={true}
                  liveStreamTypeIcon={getLiveStreamIcon(liveStream.livestreamable_type)}
                  liveStreamImageUrl={getLiveStreamImageUrl(liveStream)}
                  clickedLiveStream={this.showLiveStream}
                  key={"live-stream-"+liveStream.id}
                />
              )
            })}
          </React.Fragment>
        }
        {upcomingLiveStreams.length > 0 &&
          <React.Fragment>
            <div className="fs-md cs-black fw-sb my2">Upcoming Livestreams</div>
            {upcomingLiveStreams.map((liveStream) => {
              return(
                <LiveStreamItem
                  liveStream={liveStream}
                  isLive={false}
                  liveStreamTypeIcon={getLiveStreamIcon(liveStream.livestreamable_type)}
                  liveStreamImageUrl={getLiveStreamImageUrl(liveStream)}
                  clickedLiveStream={this.showLiveStream}
                  key={"live-stream-"+liveStream.id}
                />
              )
            })}
          </React.Fragment>
        }
        {pastLiveStreams.length > 0 &&
          <React.Fragment>
            <div className="fs-md cs-black fw-sb my2">Past Livestreams</div>
            {pastLiveStreams.map((liveStream) => {
              return(
                <LiveStreamItem
                  liveStream={liveStream}
                  isLive={false}
                  liveStreamTypeIcon={getLiveStreamIcon(liveStream.livestreamable_type)}
                  liveStreamImageUrl={getLiveStreamImageUrl(liveStream)}
                  clickedLiveStream={this.showLiveStream}
                  key={"live-stream-"+liveStream.id}
                />
              )
            })}
          </React.Fragment>
        }
      </div>
    );
  }
}

export default LiveStreamList;
